import LayoutWeb from "../LayoutWeb/layoutWeb";

const WebManagement = () => {
  return <LayoutWeb subTitle="Gestión Web"></LayoutWeb>;
};

export default WebManagement;
